import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="base64-upload"
export default class extends Controller {
  static targets = [
    "file",
    "dataField",
    "filenameField",
    "contentTypeField",
    "preview",
    "placeholder",
    "clearButton"
  ]

  fileChanged(event) {
    const file = event.target.files[0]

    if (!file) {
      this.clear()
      return
    }

    if (!file.type.startsWith("image/")) {
      this.dispatch("error", { detail: { message: "Please choose an image file." } })
      this.clear()
      return
    }

    const reader = new FileReader()

    reader.onload = () => {
      const result = reader.result
      const base64Index = result.indexOf("base64,")

      if (base64Index === -1) {
        this.dispatch("error", { detail: { message: "Unable to read file." } })
        this.clear()
        return
      }

      const base64Data = result.slice(base64Index + 7)

      this.dataFieldTarget.value = base64Data
      this.filenameFieldTarget.value = file.name
      this.contentTypeFieldTarget.value = file.type

      if (this.hasPreviewTarget) {
        this.previewTarget.src = result
        this.previewTarget.classList.remove("hidden")
      }

      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add("hidden")
      }

      if (this.hasClearButtonTarget) {
        this.clearButtonTarget.classList.remove("hidden")
      }
    }

    reader.readAsDataURL(file)
  }

  clear() {
    if (this.hasFileTarget) {
      this.fileTarget.value = ""
    }

    this.dataFieldTarget.value = ""
    this.filenameFieldTarget.value = ""
    this.contentTypeFieldTarget.value = ""

    if (this.hasPreviewTarget) {
      this.previewTarget.src = ""
      this.previewTarget.classList.add("hidden")
    }

    if (this.hasPlaceholderTarget) {
      this.placeholderTarget.classList.remove("hidden")
    }

    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.add("hidden")
    }
  }
}
